var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "调价记录",
            visible: _vm.dialogVisible,
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.priceAdjustmentList, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "skuId", label: "SKU ID", width: "180" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "skuName", label: "SKU 名称", width: "180" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "newSupplyPrice", label: "价格" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "", label: "调价范围" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", { staticStyle: { color: "#F56C6C" } }, [
                              _vm._v(
                                _vm._s(
                                  scope.row.newSupplyPrice -
                                    scope.row.oldSupplyPrice >
                                    0
                                    ? "上调￥" +
                                        (Number(scope.row.newSupplyPrice) -
                                          Number(
                                            scope.row.oldSupplyPrice
                                          ).toFixed(2)) +
                                        "元 ↑"
                                    : ""
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticStyle: { color: "#67C23A" } }, [
                              _vm._v(
                                _vm._s(
                                  scope.row.newSupplyPrice -
                                    scope.row.oldSupplyPrice <
                                    0
                                    ? "下调￥" +
                                        (Number(scope.row.oldSupplyPrice) -
                                          Number(
                                            scope.row.newSupplyPrice
                                          ).toFixed(2)) +
                                        "元 ↓"
                                    : ""
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.newSupplyPrice -
                                    scope.row.oldSupplyPrice ==
                                    0
                                    ? "未变动"
                                    : ""
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _vm.priceAdjustmentTitle === "store"
                    ? _c("el-table-column", {
                        attrs: { prop: "verifyAdminName", label: "审核人" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "submitName", label: "提交人" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "createTime", label: "调动时间" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }